import { Link } from 'react-router-dom';

export function TermsView() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="prose prose-slate dark:prose-invert max-w-none">
        <h1 className="text-3xl font-bold mb-8">Mentions légales</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            1. Présentation du site :
          </h2>
          <p>
            Conformément aux dispositions des articles 6-III et 19 de la Loi n°
            2004-575 du 21 juin 2004 pour la Confiance dans l'économie
            numérique, dite L.C.E.N., nous portons à la connaissance des
            utilisateurs et visiteurs du site : octave-telecom.fr les
            informations suivantes :
          </p>

          <div className="bg-muted p-6 rounded-lg mt-4">
            <h3 className="font-semibold mb-2">Informations légales :</h3>
            <ul className="list-none space-y-2">
              <li>
                <strong>Nom de la Société :</strong> Octave-telecom – SAS 799
                282 934 00030
              </li>
              <li>
                <strong>Adresse :</strong> 229 rue Saint Honoré – Paris
              </li>
              <li>
                <strong>SIREN :</strong> 799 282 934
              </li>
              <li>
                <strong>Email :</strong> hello@octave-telecom.fr
              </li>
            </ul>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            2. Description des services fournis :
          </h2>
          <p>
            Le site octave-telecom.fr a pour objet de fournir une information
            concernant l'ensemble des activités de la société.
          </p>
          {/* ... rest of section 2 content ... */}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            3. Propriété intellectuelle et contrefaçons :
          </h2>
          <p>
            Le propriétaire du site est propriétaire des droits de propriété
            intellectuelle ou détient les droits d'usage sur tous les éléments
            accessibles sur le site, notamment les textes, images, graphismes,
            logo, icônes, sons, logiciels…
          </p>
          {/* ... rest of section 3 content ... */}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            4. Liens hypertextes et cookies :
          </h2>
          <p>
            Le site octave-telecom.fr contient un certain nombre de liens
            hypertextes vers d'autres sites (partenaires, informations …) mis en
            place avec l'autorisation du propriétaire du site.
          </p>
          {/* ... rest of section 4 content ... */}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            5. Protection des biens et des personnes – gestion des données
            personnelles :
          </h2>
          <p>
            <strong>Utilisateur :</strong> Internaute se connectant, utilisant
            le site susnommé : octave-telecom.fr
          </p>
          {/* ... rest of section 5 content ... */}
        </section>

        <div className="mt-8 border-t pt-8">
          <Link
            to="/login"
            className="text-primary hover:text-primary/80 underline underline-offset-4"
          >
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
